<template>
  <a-modal
      title="选择补抽人员"
      :visible="visible"
      :maskClosable="false"
      :width="1280"
      destroyOnClose
      @ok="onSave"
      @cancel="$emit('cancel')"
      :confirmLoading="loading">
    <table class="fx-form-view" style="text-align: center">
      <tr>
        <th>品目名称</th>
        <th>品目代码</th>
        <th>区域限制</th>
        <th>需补抽人数</th>
        <th>补抽人员</th>
        <th>选择补抽人员</th>
      </tr>
      <tbody v-for="item in redrawExtractItem">
      <tr>
        <td>{{ item.fspmmc }}</td>
        <td>{{ item.fspmbm }}</td>
        <td>{{ item.extras && item.extras.areaAddressText }}</td>
        <td>{{ item.applyNum }}</td>
        <td>
          <a-tag v-for="item in item.extractExpertList" color="green" :key="item.id">{{ item.expertName }}</a-tag>
        </td>
        <th>
          <a-button type="primary" @click="onSelectItemChange(item)">选择</a-button>
        </th>
      </tr>
      </tbody>
    </table>
    <appoint-extract-expert-modal ref="appointExtractRef2" :visible="appointExtractVisible2" :apply-id="applyId"
                                  @cancel="appointExtractVisible2 = false"
                                  @success="onAppointExtractSuccess2"/>
  </a-modal>
</template>

<script>
import { AppointExtractExpert, RedrawExpert } from '@/epp/expertmain/selectexpertapply/api/ExpertApplyRequest'
import AppointExtractExpertModal from '@/epp/expertmain/selectexpertapply/modal/AppointExtractExpertModal.vue'
import { TipsMessage } from '@/epp/expertmain/selectexpertapply/utils/ExpertApplyUtils'

export default {
  name: 'PerAppointExpertModal',
  components: { AppointExtractExpertModal },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    applyId: {
      type: String,
      default: undefined
    },
  },
  data () {
    return {
      redrawExtractItem: [],
      loading: false,
      appointExtractVisible2: false,
      isLevel: undefined,
      itemId: undefined
    }
  },
  methods: {
    //初始化数据
    initData (isLevel, result) {
      this.redrawExtractItem = result
      this.isLevel = isLevel
    },
    //选择补抽的人员
    onSelectItemChange (item) {
      this.appointExtractVisible2 = true
      this.itemId = item.id
      // 获取所有已选专家id
      let selectedExpertId = this.redrawExtractItem.flatMap(item2 => item2.id !== item.id ? item2.expertIdList || [] : [])
      this.$refs.appointExtractRef2.onLoadData(this.isLevel, item.applyNum, false, [], selectedExpertId)
    },
    onAppointExtractSuccess2 (data) {
      this.appointExtractVisible2 = false
      const item = this.redrawExtractItem.find(item => item.id === this.itemId)
      if (item) {
        item.extractExpertList = [...data]
        item.expertIdList = data.map(item => item.id)
      }
    },
    //回传输入的值
    onSave () {
      let that = this
      let newData = that.redrawExtractItem.filter(item => !item.extractExpertList || item.extractExpertList.length === 0)
      if (newData.length === that.redrawExtractItem.length) {
        TipsMessage(this, '$warning', '请至少选择一个专家')
        return
      }
      //如果是补抽进来的，则要全部选中对应专家后才能保存
      // let item = that.redrawExtractItem.find(item => {
      //   let num = item.extractExpertList && item.extractExpertList.length
      //   return item.applyNum !== num || !item.extractExpertList
      // })
      // if (!this.isLevel && item) {
      //   this.$warning({
      //     title: '提示',
      //     content: `专家未抽取完成`
      //   })
      //   return
      // }
      let data = {
        applyId: that.applyId,
        isLevel: this.isLevel,
        appointExpertItem: [...that.redrawExtractItem]
      }
      that.doAppointExtractExpert(data)
    },
    async doAppointExtractExpert (data) {
      try {
        this.loading = true
        let res = await AppointExtractExpert(data)
        if (200 !== res.code) {
          TipsMessage(this, '$error', '抽取失败')
          this.$message.error('选择失败')
          return
        }
        TipsMessage(this, '$success', '抽取成功')
        this.$emit('success')
      } catch (e) {
        this.$message.error(e.message)
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>

</style>
